// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Общие стили для модального окна */
.modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
}

.modal-content {
    background: #FFFFFF;
    padding: 20px;
    border-radius: 8px;
    width: 500px;
    max-width: 90%;
    text-align: left;
    display: flex;
    flex-direction: column;
    gap: 16px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    position: relative;
}

/* Заголовок модального окна */
.modal-content h2 {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 10px;
    color: #333;
}

/* Поле для текста */
.modal-content p {
    font-size: 16px;
    color: #4B5563;
    line-height: 1.5;
    margin-bottom: 10px;
}

/* Карта */
.map-container {
    width: 100%;
    height: 300px;
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 10px;
}

/* Кнопка закрытия */
.close-button {
    /*position: absolute;*/
    /*top: 12px;*/
    /*right: 12px;*/
    background: transparent;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #333;
}

.close-button:hover {
    color: #FF0000;
}

/* Дополнительная информация */
.info-field {
    display: flex;
    flex-direction: column;
    margin-bottom: 8px;
}

.info-label {
    font-weight: bold;
    color: #333;
    margin-bottom: 4px;
}

.info-value {
    font-size: 16px;
    color: #4B5563;
}

@media (max-width: 600px) {
    .modal-content {
        width: 90%;
        padding: 15px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/style/ViewPointModal.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,0CAA0C;IAC1C,kBAAkB;AACtB;;AAEA,8BAA8B;AAC9B;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;AACf;;AAEA,oBAAoB;AACpB;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,UAAU;AACV;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,oBAAoB;AACpB;IACI,sBAAsB;IACtB,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA,8BAA8B;AAC9B;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI;QACI,UAAU;QACV,aAAa;IACjB;AACJ","sourcesContent":["/* Общие стили для модального окна */\n.modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 10;\n}\n\n.modal-content {\n    background: #FFFFFF;\n    padding: 20px;\n    border-radius: 8px;\n    width: 500px;\n    max-width: 90%;\n    text-align: left;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n    position: relative;\n}\n\n/* Заголовок модального окна */\n.modal-content h2 {\n    font-size: 20px;\n    font-weight: bold;\n    margin-bottom: 10px;\n    color: #333;\n}\n\n/* Поле для текста */\n.modal-content p {\n    font-size: 16px;\n    color: #4B5563;\n    line-height: 1.5;\n    margin-bottom: 10px;\n}\n\n/* Карта */\n.map-container {\n    width: 100%;\n    height: 300px;\n    border-radius: 8px;\n    overflow: hidden;\n    margin-bottom: 10px;\n}\n\n/* Кнопка закрытия */\n.close-button {\n    /*position: absolute;*/\n    /*top: 12px;*/\n    /*right: 12px;*/\n    background: transparent;\n    border: none;\n    font-size: 24px;\n    cursor: pointer;\n    color: #333;\n}\n\n.close-button:hover {\n    color: #FF0000;\n}\n\n/* Дополнительная информация */\n.info-field {\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 8px;\n}\n\n.info-label {\n    font-weight: bold;\n    color: #333;\n    margin-bottom: 4px;\n}\n\n.info-value {\n    font-size: 16px;\n    color: #4B5563;\n}\n\n@media (max-width: 600px) {\n    .modal-content {\n        width: 90%;\n        padding: 15px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
